import { LabourDtoResponse } from '../../../core/models/labour.dto-response';

export class LabourModel {
    labour: LabourDtoResponse;
    quantity: number;
}
